import { defineMessages } from 'react-intl';

const translations = {
  addressOptions: {
    address: {
      id: 'addressOptions.address',
      defaultMessage: 'Address',
      description: 'label of the address option address',
    },
    location: {
      id: 'addressOptions.location',
      defaultMessage: 'Location',
      description: 'label of the address option location',
    },
  },
  typeOptions: {
    inbound: {
      id: 'properties.inbound',
      defaultMessage: 'Inbound',
      description: 'label of the type option inbound',
    },
    outbound: {
      id: 'properties.outbound',
      defaultMessage: 'Outbound',
      description: 'label of the type option outbound',
    },
    transfer: {
      id: 'properties.transfer',
      defaultMessage: 'Transfer',
      description: 'label of the type option transfer',
    },
  },
  otherTypeOptions: {
    outbound: {
      id: 'shipmentFormSection.otherTypeOptions.outbound',
      defaultMessage: 'Create inbound shipment',
      description: 'message of the other type option outbound',
    },
    inbound: {
      id: 'shipmentFormSection.otherTypeOptions.inbound',
      defaultMessage: 'Create outbound shipment',
      description: 'message of the other type option inbound',
    },
  },
  fields: {
    expectedAt: {
      label: {
        id: 'properties.expectedAt',
        defaultMessage: 'Expected at',
        description: 'label of the form field expected at',
      },
    },
    shipAt: {
      label: {
        id: 'properties.shipAt',
        defaultMessage: 'Ship at',
        description: 'label of the form field ship at',
      },
    },
    method: {
      label: {
        id: 'properties.shippingMethod',
        defaultMessage: 'Shipping method',
        description: 'label of the form field method',
      },
    },
    fromAddress: {
      label: {
        id: 'properties.fromAddress',
        defaultMessage: 'From address',
        description: 'label of the form field from address',
      },
    },
    toAddress: {
      label: {
        id: 'properties.toAddress',
        defaultMessage: 'To address',
        description: 'label of the form field to address',
      },
    },
    isOutbound: {
      label: {
        id: 'properties.type',
        defaultMessage: 'Type',
        description: 'label of the form field type',
      },
    },
  },
};

export default defineMessages(translations);
